import { CognitoUserPool } from 'amazon-cognito-identity-js';

// This is the user pool for the slide scan app and Storage to be used is session storage
const poolData = {
    UserPoolId: 'us-east-1_U4dN05VIF',
    ClientId: '4b4cjo07jb81eu1b2s4ate8u3s',
    Storage: sessionStorage
};

export default new CognitoUserPool(poolData);